import model from './model';

export default model.createController(({ $bind, $widget, flowAPI }) => {
  return {
    pageReady: async () => {
      $widget.fireEvent('widgetLoaded', {});
    },
    exports: {},
  };
});
